import { render } from "./ClientQuote.vue?vue&type=template&id=3a236d11"
import script from "./ClientQuote.vue?vue&type=script&lang=js"
export * from "./ClientQuote.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__